// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__3TDDw","content":"ManualTimeModal_content__U6cT2"};